export default function initTeamDialog() {
    const dialog = document.querySelector(".team-dialog");
    if (!dialog) return;

    const closeBtn = dialog.querySelector(".closeProfile");
    if (!closeBtn) return;

    // Helper to clean empty/HTML/whitespace values
    function clean(value) {
        if (!value) return null;
        const stripped = value.replace(/<[^>]*>/g, "").trim();
        return stripped.length ? stripped : null;
    }

    document.addEventListener("click", (e) => {
        const btn = e.target.closest(".showProfile");
        if (!btn) return;

        const tile = btn.closest(".team-tile");
        if (!tile) return;

        const rawData = tile.getAttribute("data-profile");
        if (!rawData) return;

        let data;
        try {
            data = JSON.parse(rawData);

            // Normalise values
            data.email = clean(data.email);
            data.linkedin = clean(data.linkedin);

        } catch {
            return;
        }

        // Populate dialog
        const img = dialog.querySelector(".team-dialog__inner__pp img");
        if (img) {
            img.src = data.image ? `${data.image}?width=300&height=300&mode=crop` : "";
            img.alt = data.name || "";
        }

        const title = dialog.querySelector(".team-dialog__inner__header .title");
        const job = dialog.querySelector(".team-dialog__inner__header .job");
        const body = dialog.querySelector(".team-dialog__inner__body");

        if (title) title.textContent = data.name || "";
        if (job) job.textContent = data.job || "";
        if (body) body.innerHTML = data.bio || "";

        // Email + LinkedIn buttons
        const emailBtn = dialog.querySelector(".emailBtn");
        const linkedinBtn = dialog.querySelector(".linkedinBtn");

        if (emailBtn) {
            if (data.email) {
                emailBtn.href = `mailto:${data.email}`;
                emailBtn.removeAttribute("hidden");
            } else {
                emailBtn.setAttribute("hidden", "");
            }
        }

        if (linkedinBtn) {
            if (data.linkedin) {
                linkedinBtn.href = data.linkedin;
                linkedinBtn.removeAttribute("hidden");
            } else {
                linkedinBtn.setAttribute("hidden", "");
            }
        }

        dialog.removeAttribute("hidden");
        dialog.classList.add("open");
        document.body.classList.add("no-scroll");
    });

    closeBtn.addEventListener("click", () => {
        dialog.classList.remove("open");
        dialog.setAttribute("hidden", "");
        document.body.classList.remove("no-scroll");
    });
}